import api from "./axios";

export const getAllUsers = async () => {
  const response = await api.get("/users/all");
  return response.data;
};

export const getUsersByRole = async (role) => {
  const response = await api.get("/users/by-role", { params: { role } });
  return response.data;
};

export const createUser = async (user) => {
  const body = {
    name: user.name,
    surname: user.surname,
    username: user.username,
    email: user.email,
    password: user.password,
    position: user.position,
    company_name: user.company_name,
    is_active: user.is_active,
  };
  const response = await api.post("/users", body);
  return response.data;
};

export const deleteUser = async (userId) => {
  const response = await api.delete("/users/" + userId);
  return response.data;
};

export const assignRoleToUser = async (email, role) => {
  const response = await api.post("/users/role", { email, role });
  return response.data;
};
